import React, { useEffect } from "react";
import "./Administration.scss";
import getStyles from "./getStyles";
import Button from "@material-ui/core/Button";
import { Add, Edit } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { Backdrop, CircularProgress, InputAdornment } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import CompanyCreationModal from "../CompanyCreationModal";
import BranchCreationModal from "../BranchCreationModal";
import UserCreationModal from "../UserCreationModal/UserCreationModal";
import SearchResults from "../SearchResults";
import CompanyTree from "../CompanyTree";
import CompanyDetails from "../CompanyDetails";
import BranchDetails from "../BranchDetails";
import UserDetails from "../UserDetails";
import LinearProgress from "@material-ui/core/LinearProgress";
import AccountBalance from "@material-ui/icons/AccountBalance";

const Administration = (props: any) => {
  const classes = getStyles();
  const [treeData, setTreeData] = React.useState<any>({});
  const [searchText, setSearchText] = React.useState<string>("");
  const [openCompanyCreationModal, setOpenCompanyModal] = React.useState<any>({
    open: false,
    action: ""
  });
  const [openBranchCreationModal, setOpenBranchModal] = React.useState<any>({
    open: false,
    action: ""
  });
  const [openUserCreationModal, setOpenUserModal] = React.useState<any>({
    open: false,
    action: ""
  });
  const [itemAction, setItemAction] = React.useState<any[]>([
    { action: "Add", type: "Company" }
  ]);
  const [showAllCompanies, setShowAllCompanies] = React.useState(true);
  const [showCompanyDetails, setShowCompanyDetails] = React.useState(false);
  const [showBranchDetails, setShowBranchDetails] = React.useState(false);
  const [showUserDetails, setShowUserDetails] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string[]>([]);
  const [limitedBranchesMessage, setLimitedBranchesMessage] = React.useState<
    boolean
  >(false);
  const [limitedUsersMessage, setLimitedUsersMessage] = React.useState<boolean>(
    false
  );

  useEffect(() => {
    setTreeData(props.treeData);
  }, [props.treeData]);

  useEffect(() => {
    setOpenUserModal(false);
  }, [props.userChangeCount]);

  function handleOpenActionModal(type: string, action: string) {
    openModalByItemType(type, action);
  }

  function openModalByItemType(type: string, action: string) {
    if (action === "Add") {
      if (type === "Company") {
        setOpenCompanyModal({ open: true, action: "Add" });
      } else if (type === "Branch") {
        setOpenBranchModal({ open: true, action: "Add" });
      } else if (type === "User") {
        setOpenUserModal({ open: true, action: "Add" });
      }
    }

    if (action === "Edit") {
      if (type === "Company") {
        setOpenCompanyModal({ open: true, action: "Edit" });
      } else if (type === "Branch") {
        setOpenBranchModal({ open: true, action: "Edit" });
      } else if (type === "User") {
        setOpenUserModal({ open: true, action: "Edit" });
      }
    }
  }

  function openCloseNode(id: string): void {
    const isOpen = expanded.includes(id);
    if (id === "/" && isOpen) {
      setExpanded([]);
    } else if (isOpen) {
      setExpanded(x => x.filter(i => !(i.startsWith(id + "/") || i === id)));
    } else {
      setExpanded(x => x.concat([id]));
    }
  }

  function selectCompany(companyId: string) {
    openCloseNode("/" + companyId);
    if (props.onLoadCompany) {
      props.onLoadCompany(companyId);
    }
    setItemAction([
      { action: "Add", type: "Branch" },
      { action: "Edit", type: "Company" }
    ]);
    setShowAllCompanies(false);
    setShowCompanyDetails(true);
    setShowBranchDetails(false);
    setShowUserDetails(false);
  }

  function selectBranch(companyId: string, branchId: number) {
    openCloseNode("/" + companyId + "/" + branchId);
    if (props.onLoadBranch) {
      props.onLoadBranch(companyId, branchId);
    }
    setItemAction([
      { action: "Add", type: "User" },
      { action: "Edit", type: "Branch" }
    ]);
    setShowAllCompanies(false);
    setShowCompanyDetails(false);
    setShowBranchDetails(true);
    setShowUserDetails(false);
  }

  function selectUser(companyId: string, userId: number) {
    setItemAction([]);
    if (props.onLoadUser) {
      props.onLoadUser(companyId, userId);
    }
    setItemAction([{ action: "Edit", type: "User" }]);
    setShowAllCompanies(false);
    setShowCompanyDetails(false);
    setShowBranchDetails(false);
    setShowUserDetails(true);
  }

  return (
    <div className={`${classes.root} Administration-container`}>
      <div className="Administration-topPanel">
        <div className="Administration-header" />
        <div>
          {props.permissions &&
            props.permissions.admin &&
            itemAction.map(item => (
              <Button
                onClick={() => handleOpenActionModal(item.type, item.action)}
                key={`ActionButton-${item.action}-${item.type}`}
                className={
                  item.action === "Add"
                    ? "Administration-addButton"
                    : "Administration-editButton"
                }
                disabled={props.branchLoading || props.companyLoading}
                variant="contained"
                color="primary"
                startIcon={
                  item.action === "Add" ? (
                    <Add className="Administration-addIcon" />
                  ) : (
                    <Edit className="Administration-editIcon" />
                  )
                }
              >
                {item.action} {item.type}
              </Button>
            ))}
        </div>
      </div>

      <div className="Administration-informationContainer">
        <div className="Administration-treeContainer">
          {limitedBranchesMessage || limitedUsersMessage ? (
            <p className="Administration-viewTableMessage">
              * {showCompanyDetails ? "Company" : "Branch"} has more{" "}
              {showCompanyDetails ? "branches" : "users"} than those currently
              being displayed on the tree. Please refer to the{" "}
              {showCompanyDetails ? "company" : "branch"} table on the right for
              a detailed view.
            </p>
          ) : (
            <></>
          )}

          <TextField
            placeholder={"Please type first 4 characters"}
            className={`${classes.searchField} Administration-search`}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            type="search"
            value={searchText}
            onChange={(evt: any) => {
              const s = evt.target.value;
              if (!s) {
                setExpanded(["/"]);
                setItemAction([{ action: "Add", type: "Company" }]);
                setShowAllCompanies(true);
                setShowCompanyDetails(false);
                setShowBranchDetails(false);
                setShowUserDetails(false);
              }
              setSearchText(s);
              if (props.onSearchChange) {
                props.onSearchChange(s);
              }
            }}
          />

          <LinearProgress
            variant="determinate"
            classes={{
              barColorPrimary:
                searchText.length >= 4
                  ? classes.barColorComplete
                  : classes.barColorIncomplete
            }}
            value={
              searchText.length >= 4
                ? 100
                : searchText.length === 3
                ? 75
                : searchText.length === 2
                ? 50
                : searchText.length === 1
                ? 25
                : 0
            }
          />

          {searchText ? (
            <SearchResults
              className="Administration-searchResults"
              results={props.searchResults}
              onSelectCompany={(company: any) => selectCompany(company)}
              onSelectBranch={(companyId: string, branchId: number) =>
                selectBranch(companyId, branchId)
              }
              onSelectUser={(companyId: string, userId: number) =>
                selectUser(companyId, userId)
              }
            />
          ) : (
            <CompanyTree
              expanded={expanded}
              openCloseNode={openCloseNode}
              setItemAction={setItemAction}
              setShowAllCompanies={setShowAllCompanies}
              setShowCompanyDetails={setShowCompanyDetails}
              setShowBranchDetails={setShowBranchDetails}
              setShowUserDetails={setShowUserDetails}
              data={treeData}
              selectCompany={selectCompany}
              selectBranch={selectBranch}
              selectUser={selectUser}
              setLimitedBranchesMessage={(hasOver20Branches: boolean) => {
                setLimitedBranchesMessage(hasOver20Branches);
              }}
              setLimitedUsersMessage={(hasOver20Users: boolean) => {
                setLimitedUsersMessage(hasOver20Users);
              }}
            />
          )}
        </div>

        <div className="Administration-tableContainer">
          {showAllCompanies ? (
            <div>
              <div className="Administration-tableTitle">Companies</div>
              <table className="CompaniesTable-container">
                <thead className="CompaniesTable--headPanel">
                  <tr className="CompaniesTable--headPanelRow">
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {treeData &&
                    treeData.companies &&
                    treeData.companies.map((company: any) => (
                      <tr
                        key={`CompanyList-${company.id}`}
                        className="CompaniesTable--row"
                        onClick={() => setShowBranchDetails(true)}
                      >
                        <td className="CompaniesTable-Name">{company.name}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {showAllCompanies &&
              (!treeData ||
                (treeData.companies && treeData.companies.length === 0) ||
                treeData.length === 0) ? (
                <div className="CompaniesTable--noDataContainer">
                  <AccountBalance className="CompaniesTable--noDataIcon" />
                  <p className="CompaniesTable--noDataText">
                    There are currently no companies to display.
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}

          {props.selectedCompany && showCompanyDetails ? (
            <CompanyDetails
              showBranches={
                props.permissions &&
                (props.permissions.admin || props.permissions.readBranches)
              }
              company={props.selectedCompany}
              setShowBranchDetails={setShowBranchDetails}
              currencies={props.currencies}
              currenciesLoading={props.currenciesLoading}
            />
          ) : (
            <></>
          )}

          {props.selectedBranch && showBranchDetails ? (
            <BranchDetails
              branch={props.selectedBranch}
              showPeople={props.permissions && props.permissions.admin}
            />
          ) : (
            <></>
          )}

          {props.selectedUser && showUserDetails ? (
            <UserDetails user={props.selectedUser} />
          ) : (
            <></>
          )}
        </div>
      </div>
      <CompanyCreationModal
        action={openCompanyCreationModal.action}
        open={openCompanyCreationModal.open}
        close={() => setOpenCompanyModal({ open: false, action: "" })}
        value={props.selectedCompany}
        onCreate={async (
          name: any,
          fxRateType: any,
          rateCardEmailAddresses: any,
          marginsAndCharges: any,
          fcaCurrencies: any,
          settlement: any
        ) => {
          if (props.onCreateCompany) {
            await props.onCreateCompany(
              name,
              fxRateType,
              rateCardEmailAddresses,
              marginsAndCharges,
              fcaCurrencies,
              settlement
            );
            setExpanded(["/"]);
          }
          setOpenCompanyModal(false);
        }}
        onUpdateCompany={async (
          name: any,
          fxRateType: any,
          rateCardEmailAddresses: any,
          marginsAndCharges: any,
          fcaCurrencies: any,
          settlement: any
        ) => {
          if (props.onUpdateCompany) {
            await props.onUpdateCompany(
              name,
              fxRateType,
              rateCardEmailAddresses,
              marginsAndCharges,
              fcaCurrencies,
              settlement
            );
            setExpanded(["/"]);
          }
          setOpenCompanyModal(false);
        }}
        currencies={props.currencies}
        currenciesLoading={props.currenciesLoading}
      />
      <BranchCreationModal
        action={openBranchCreationModal.action}
        open={openBranchCreationModal.open}
        value={props.selectedBranch}
        close={() => setOpenBranchModal({ open: false, action: "" })}
        onCreate={(branch: any) => {
          props.onCreateBranch(branch);
          setOpenBranchModal(false);
        }}
        onUpdate={(branch: any) => {
          props.onUpdateBranch(branch);
          setOpenBranchModal(false);
          const companyId = props.selectedCompany.id;
          const branchId = props.selectedBranch.id;
          props.onLoadBranch(companyId, branchId);
          const key = "/" + companyId + "/" + branchId;
          setExpanded(x =>
            x.filter(i => !(i.startsWith(key + "/") || i === key))
          );
        }}
      />
      {props.selectedCompany && (props.selectedBranch || props.selectedUser) && (
        <UserCreationModal
          action={openUserCreationModal.action}
          open={openUserCreationModal.open}
          close={() => setOpenUserModal({ open: false, action: "" })}
          value={props.selectedUser}
          selectedBranch={
            props.selectedUser && openUserCreationModal.action === "Edit"
              ? props.selectedUser.branches
              : props.selectedBranch
              ? [props.selectedBranch]
              : null
          }
          onCreate={async (user: any) => {
            if (props.onCreateUser) {
              await props.onCreateUser(user);
            }
          }}
          onUpdate={async (user: any) => {
            if (props.onUpdateUser) {
              await props.onUpdateUser(user);
            }
            const companyId = props.selectedCompany.id;
            const branches = props.selectedUser.branches;
            // Close up this person's branch folders
            for (let i = 0; i < branches.length; i++) {
              const branchId = branches[i].id;
              props.onLoadBranch(companyId, branchId);
              const key = "/" + companyId + "/" + branchId;
              setExpanded(x =>
                x.filter(i => !(i.startsWith(key + "/") || i === key))
              );
            }
          }}
          branches={props.selectedCompany.branches}
          duplicateEmail={props.duplicateEmail}
        />
      )}
      {props.isSaving &&
      (openCompanyCreationModal.open ||
        openBranchCreationModal.open ||
        openUserCreationModal.open) ? (
        <div>
          <Backdrop
            className={classes.progressBackdrop}
            open={true}
            onClick={e => e.stopPropagation()}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default Administration;
